export default "__VITE_ASSET__D$hVsLil__"